module.exports = require('./_hide');


/*****************
 ** WEBPACK FOOTER
 ** ./~/.2.4.1@core-js/library/modules/_redefine.js
 ** module id = 187
 ** module chunks = 0
 **/